import { IconFilter } from "components/icons";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { UnitTypeResponse, UserSettingsDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AdvancedFilter, IAdvFilterCommand } from "views/general/AdvancedFilter";
import { FilterCmd } from "views/general/AdvancedFilter/FilterCmd";
import { IUserFilterOptions } from "./UserAdvSelector";

interface IProps {
    filterOptions: IUserFilterOptions;
    onFilterChange: (filter: IUserFilterOptions) => void;
}

export const Filter: React.FC<IProps> = ({ filterOptions, onFilterChange }) => {
    const api = useCoreApi();
    const { t } = useTranslation();

    const [userSettings, setUserSettings] = useState<UserSettingsDto | undefined>();
    const [unitTypes, setUnitTypes] = useState<UnitTypeResponse[]>([]);

    ///
    const dropdownOptions = (): IAdvFilterCommand[] => {
        var options: IAdvFilterCommand[] = [
            FilterCmd.User.tag(1),
            FilterCmd.User.workplace(1, userSettings),

            ...FilterCmd.User.unitType(unitTypes, 2),

            FilterCmd.User.group(3),
            FilterCmd.User.roles(3),
            FilterCmd.User.permission(3),
            FilterCmd.User.customField(3),

            FilterCmd.User.topicOptional(4),
            FilterCmd.User.topicRequired(4),
            FilterCmd.User.hasSealProvenKnowledgeTopic(4),
            FilterCmd.User.isSpecialistInTopic(4),
            FilterCmd.User.interestTag(4),

            FilterCmd.User.isManager(5),
            FilterCmd.User.managerDirectSubordinates(5),
            FilterCmd.User.managerAllSubordinates(5),

            FilterCmd.User.includeInactive(6),
            FilterCmd.User.includeBlockedUsers(6),
            FilterCmd.User.suspendedAccounts(6),

            FilterCmd.User.lastAccessBeforeOf(7),
            FilterCmd.User.lastAccessAfterOf(7),

            FilterCmd.General.combineUsingOR(9),
        ];

        return options;
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {

        async function getData() {
            try {
                let settings = await api.v1.foundationSettings.getUserSettings();
                setUserSettings(settings.data);
            } catch (e: any) {
                MprcRequestSnackbarErrorReport(e);
            }

            try {
                let result = await api.v1.unitType.getUnitTypes();
                setUnitTypes(result.data);
            } catch (e: any) {
                MprcRequestSnackbarErrorReport(e);
            }
        }
        getData();
    }, []);

    return (
        <AdvancedFilter
            filter={filterOptions}
            searchTextInFilterLine
            leftDropdowns={[{
                filterCommands: dropdownOptions(),
                textOrIcon: <IconFilter />,
                title: t("shared:AdvFilter.Title")
            }]}
            leftDropdownAlign="end"
            chipsPosition="top"
            onFilterChange={(filter) => onFilterChange({ ...filterOptions, ...filter })}
            onError={error => MprcRequestSnackbarErrorReport(error)}
        />
    );
};
